import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Creators } from '../../../duck/actions';
import AdBanner from '../../common/AdBanner/AdBanner';
import OuterBox from '../../common/OuterBox/OuterBox';
import InnerBox from '../../common/InnerBox/InnerBox';
import {
  ListElement,
  Title,
  // StyledLine,
  // StyledLineInside,
  Content,
  AuthorAndTime,
  Image,
  FlexContainer
} from '../../common/StyledComponents';
import RelatedArticles from '../../common/RelatedArticles/RelatedArticles';
import Breadcrumb from '../../common/Breadcrumb/Breadcrumb';
import {
  // isVisible,
  createMarkup
} from '../../../utils/utils';
import Comments from '../../common/Comments/Comments';
import adTissot from '../../../assets/images/ad-tissot.png';
import adSuggested from '../../../assets/images/ad-suggested.png';
// import adSeparator from '../../../assets/images/ad-separator.png';
import StickyHeader from '../../common/Navigation/StickyHeader/StickyHeader';
import { SideBar } from '../../common/StyledComponents/StyledSideBar';
import List_XS_Image from '../../common/ListWithImage/List_XS_Image';
import List_S_Image from '../../common/ListWithImage/List_S_Image';
import List_Vertical from '../../common/ListWithImage/List_Vertical';

import adLinkedin from '../../../assets/images/ad-linkedin.png';
import adAmazon from '../../../assets/images/ad-amazon.png';
import adAmazonVertical from '../../../assets/images/ad-amazon-vertical.png';
import adSuggestedVertical from '../../../assets/images/ad-suggested-vertical.png';
import goToTop from '../../../assets/images/gototop.png';

const handleGoToTop = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

const scrollFunction = () => {
  if (
    document.body.scrollTop > 800 ||
    document.documentElement.scrollTop > 800
  ) {
    document.getElementById('goToTopBtn').style.display = 'flex';
  } else {
    document.getElementById('goToTopBtn').style.display = 'none';
  }
};

class SingleBestOf extends Component {
  componentWillMount = () => {
    // console.log('[SingleBestOf.js] componentWillMount');
    window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    window.twttr.widgets.load();
    // console.log('[SingleBestOf.js]\nthis.props: ', this.props);
    window.scrollTo(0, 0);

    let postSlug = this.props.location.pathname.slice(1);

    this.props.onFetchSingleBestOf(postSlug);

    // if (this.props.relatedProducts === null) {
    this.props.onFetchRelatedProducts();
    this.props.onFetchBestSoftwares();
    // }

    window.addEventListener('scroll', scrollFunction);
  };

  componentWillUnmount = () => {
    window.removeEventListener('scroll', scrollFunction);
  };

  componentDidUpdate = (prevProps, prevState) => {
    window.twttr.widgets.load();
    let postSlug = this.props.location.pathname.slice(1);
    // console.log('[CDUp]\npostSlug: ', postSlug);
    let oldPostSlug = prevProps.location.pathname.slice(1);
    // console.log('[CDUp]\noldPostSlug: ', oldPostSlug);
    if (postSlug !== oldPostSlug) {
      window.scrollTo(0, 0);
      this.props.onFetchSingleBestOf(postSlug);
      if (this.props.relatedProducts === null) {
        this.props.onFetchRelatedProducts();
        this.props.onFetchBestSoftwares();
      }
      // console.log(' singleBestOf: ',  singleBestOf);
    }
  };

  contentClickHandler = e => {
    const targetLink = e.target.closest('a');
    if (!targetLink) return;
    e.preventDefault();
    e.stopPropagation();

    if (e.target.hostname === window.location.hostname) {
      // This is an Internal Link
      let x = e.target.pathname;
      if (x.slice(-1) === '/') {
        x = x.slice(0, -1);
      }
      this.props.history.replace({ pathname: x, state: `change` });
    } else {
      // This is an External Link
      window.open(e.target.href, '_blank');
    }

    // // console.log('this.props: ', this.props);
    // if (e.target.href) {
    //   this.props.history.replace(e.target.href.slice(21));
    //   // this.props.location.assign(e.target.href.slice(22));
    // }
    // console.log('e.target: ', e.target);
    // // console.log('e.target.href: ', e.target.href.slice(21));
    // console.log('targetLink.href: ', targetLink.href);
    // // history.push(e.target.href)
  };

  render() {
    const {
      relatedProducts,
      bestSoftwares,
      singleBestOf,
      relatedArticles
      // error,
      // loading,
      // onFetchSingleNews
    } = this.props;
    // let timeStamp;

    // Binding our scroll event handler
    window.onscroll = () => {
      // Fetch another SingleNews when current SingleNews reaches end.
      // let ele = document.getElementById('finalAd');
      // if (ele !== null && isVisible(ele)) {
      //   if (error || loading) return;
      //   onFetchSingleNews(null, timeStamp);
      // }

      // Show/Hide SingleNews Header on scroll down/up.
      let header = document.getElementById('Header');
      if (window.scrollY > window.oldScroll && window.scrollY > 90) {
        header.classList.add('slide-out');
        header.classList.remove('slide-in');
      } else if (window.scrollY < window.oldScroll) {
        header.classList.add('slide-in');
        header.classList.remove('slide-out');
      }
      window.oldScroll = window.scrollY;
    };

    // console.log('\n[SingleNews render]\nthis.props: ', this.props);

    let singlet3 = null;
    if (singleBestOf) {
      singlet3 = singleBestOf.map((t3, index) => {
        // timeStamp = t3.date;
        return (
          <div key={index} className="SingleNews">
            <AdBanner height="250px" width="970px" margin="18px 0 0 0">
              <Image
                src={adTissot}
                width="100%"
                height="100%"
                alt="tissot ad"
              />
            </AdBanner>

            <OuterBox>
              <InnerBox direction="column">
                {t3 && t3.bread_crumb ? (
                  <Breadcrumb crumb={t3.bread_crumb[0]} />
                ) : null}
                <ListElement className="w-100" maxwidth="100%" padding="0">
                  {/* Title */}
                  {t3 !== null && Object.keys(t3).length ? (
                    <Title
                      className="Title"
                      fontFamily="Nunito"
                      fontSize="3rem"
                      fontWeight="bold"
                      padding="0"
                      onClick={this.contentClickHandler}
                      dangerouslySetInnerHTML={createMarkup(t3.title.rendered)}
                    />
                  ) : null}

                  {/* SubTitle */}
                  {/* {t3 !== null && Object.keys(t3).length ? (
                    <Title
                      className="SubTitle"
                      fontFamily="Montserrat"
                      fontSize="1.25rem"
                      padding="0"
                      fontStyle="italic"
                      lineheight="normal"
                      letterSpacing="0.3px"
                      onClick={this.contentClickHandler}
                      dangerouslySetInnerHTML={createMarkup(
                        t3.excerpt.rendered
                      )}
                    />
                  ) : null} */}
                </ListElement>
              </InnerBox>
            </OuterBox>

            <OuterBox>
              <InnerBox>
                <ListElement padding="0px 5px 18px 5px">
                  <FlexContainer
                    alignitems="center"
                    className="AuthorImage AuthorImage PostDateTime Comments"
                  >
                    <Image
                      width="31px"
                      height="31px"
                      borderradius="50%"
                      src={t3._embedded.author[0].avatar_urls[96]}
                      alt={t3.user_meta.authorName}
                    />
                    <AuthorAndTime
                      fontFamily="Nunito"
                      fontWeight="bold"
                      color="#757575"
                      lineHeight="normal"
                      padding="0 0 0 10px"
                      className="w-100"
                    >
                      <Link to={`author/${t3._embedded.author[0].slug}`}>
                        {t3.user_meta.authorName}
                      </Link>
                      {/* <span>{t3.user_meta.authorName}</span> */}
                      <span>{t3.user_meta.postDate}</span>

                      {/* <div>{ t3.authorName}</div> */}
                      {/* <div>{ t3.authorName}</div> */}
                    </AuthorAndTime>
                  </FlexContainer>
                  {/* Content */}
                  <Image src={t3.fimg_url} alt={t3.slug} />
                  {t3 && Object.keys(t3).length ? (
                    <Content
                      id="content"
                      onClick={this.contentClickHandler}
                      dangerouslySetInnerHTML={createMarkup(
                        t3.content.rendered
                      )}
                    />
                  ) : null}
                  {/* Related Articles */}
                  {relatedArticles[index] && relatedArticles[index].length ? (
                    <RelatedArticles
                      relatedArticlesData={relatedArticles[index]}
                    />
                  ) : null}
                  {/* Comments */}
                  {t3.user_meta.countNumber > 0 ? (
                    <Comments
                      commentData={{
                        count: t3.user_meta.countNumber,
                        author: t3._embedded.author,
                        comments: t3._embedded.replies
                      }}
                    />
                  ) : null}
                </ListElement>
                <SideBar>
                  <AdBanner height="250px" width="300px" margin="0 0 18px 0">
                    <Image
                      src={adLinkedin}
                      width="100%"
                      height="100%"
                      alt="tissot ad"
                    />
                  </AdBanner>

                  {bestSoftwares ? (
                    // eslint-disable-next-line
                    <List_S_Image
                      className="List_XS_Image mb3"
                      title="Best of Laptops"
                      listItems={bestSoftwares}
                    />
                  ) : null}

                  <AdBanner height="250px" width="300px" margin="18px 0 18px 0">
                    <Image
                      src={adAmazon}
                      width="100%"
                      height="100%"
                      alt="tissot ad"
                    />
                  </AdBanner>

                  {relatedProducts ? (
                    // eslint-disable-next-line
                    <List_XS_Image
                      className="List_XS_Image mb3"
                      title="Related Products"
                      listItems={relatedProducts}
                    />
                  ) : null}
                  <AdBanner height="565px" width="300px" margin="0">
                    <Image
                      src={adSuggestedVertical}
                      width="100%"
                      height="100%"
                      alt="tissot ad"
                    />
                  </AdBanner>
                  <AdBanner height="600px" width="300px" margin="18px 0 18px 0">
                    <Image
                      src={adAmazonVertical}
                      width="100%"
                      height="100%"
                      alt="tissot ad"
                    />
                  </AdBanner>
                </SideBar>
              </InnerBox>
            </OuterBox>

            {relatedProducts ? (
              // eslint-disable-next-line
              <List_Vertical
                className="List_Vertical flex justify-center"
                title="See Also"
                listItems={relatedProducts}
              />
            ) : null}

            <AdBanner height="250px" width="970px" margin="0">
              <Image
                src={adTissot}
                width="100%"
                height="100%"
                alt="tissot ad"
              />
            </AdBanner>

            <OuterBox>
              <InnerBox>
                <ListElement className="w-100" maxwidth="100%" padding="20px">
                  {/* <Title
                    fontFamily="Montserrat"
                    fontSize="1.5rem"
                    fontWeight="bold"
                  >
                    Suggested
                  </Title>
                  <StyledLine>
                    <StyledLineInside />
                  </StyledLine>
                  <AdBanner height="210px" width="1000px" margin="0" /> */}
                  <AdBanner height="346px" width="1040px" margin="0">
                    <Image
                      src={adSuggested}
                      width="100%"
                      height="100%"
                      alt="tissot ad"
                    />
                  </AdBanner>
                </ListElement>
              </InnerBox>
            </OuterBox>
          </div>
        );
      });
    }

    // return { singlet3 };
    return (
      <Fragment>
        <StickyHeader className="StickyHeader" />
        {singlet3}
        {/* <AdBanner id="finalAd" height="1px" width="970px" margin="0" /> */}
        <div
          className="fixed dn bn outline-0 pointer"
          style={{ bottom: '18vh', right: '1rem' }}
          onClick={() => handleGoToTop()}
          id="goToTopBtn"
          title="Go to top"
        >
          <img src={goToTop} alt="goToTop" />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  // console.log('[SingleBestOf.js] state: ', state);
  return {
    relatedProducts: state.singleBestOf.relatedProducts,
    bestSoftwares: state.singleBestOf.bestSoftwares,
    singleBestOf: state.singleBestOf.singleBestOf,
    relatedArticles: state.singleBestOf.relatedArticles,
    error: state.singleBestOf.error,
    loading: state.singleBestOf.loading
  };
};

const mapDispatchToProps = dispatch => ({
  // onFetchSingleBestOf: (postSlug, timeStamp) =>
  //   dispatch(Creators.fetchSingleBestOf(postSlug, timeStamp)),
  onFetchSingleBestOf: postSlug =>
    dispatch(Creators.fetchSingleBestOf(postSlug)),
  onFetchRelatedProducts: () => dispatch(Creators.fetchRelatedProducts()),
  // onFetchRelatedArticles: (tagId, postId) =>
  //   dispatch(Creators.fetchRelatedArticlesForSingleBestOf(tagId, postId)),
  onFetchBestSoftwares: () => dispatch(Creators.fetchBestSoftwares())
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SingleBestOf)
);
